import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quizData: "",
  availableSurvey: "",
  completedSurvey: "",
  availablePolls: "",
  completedPolls:"",
  discussion:"",
  faq: "",
  magazine:"",
  error: null,
};

const thubSlice = createSlice({
  name: "thub",
  initialState: initialState,
  reducers: {
    getQuiz(state, action) {
      state.quizData = action.payload.response;
    },
    getAvailableSurvey(state, action) {
      state.availableSurvey = action.payload.response;
    },
    getCompletedSurvey(state, action) {
      state.completedSurvey = action.payload.response;
    },
    getAvailablePolls(state, action) {
      state.availablePolls = action.payload.response;
    },
    getCompletedPolls(state, action) {
      state.completedPolls = action.payload.response;
    },
    getDiscussion(state, action) {
      state.discussion = action.payload.response;
    },
    getMagazine(state, action) {
      state.magazine = action.payload.response;
    },
    getFaq(state, action) {
      state.faq = action.payload.response;
    },
    alert(state, action) {
      state.error = action.payload;
    },
  },
});

export default thubSlice.reducer;
export const thubActions = thubSlice.actions;
